<template>
  <div class="notify">
    <div class="notify-content active" @click="clicked()">
      <i class="arrow-down fa fa-bell"></i>
    </div>
    <div class="ball" v-if="notify.read.filter((n) => !n.visualizado).length > 0">
      {{ notify.read.filter((n) => !n.visualizado).length }}
    </div>
    <transition name="fade">
      <div class="container" v-if="showTab">
        <ul class="tab">
          <li v-if="!notify.read.length && !notify.readed.length">
            Não há notificações
          </li>
          <li v-for="(n, i) of notify.read" :key="'n' + i" class="row align-center"
            :class="(n.id && 'clickable') + ' ' + (!n.visualizado && 'new')" @click="openNotify(n)">
            <div class="grid-2">
              <b>{{ n.time }}</b>
            </div>
            <div class="grid-2"></div>
            <div class="grid-7">{{ n.msg }}</div>
          </li>
        </ul>

      </div>
    </transition>
    <div class="mask" @click="clicked()" v-if="showTab"></div>
  </div>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from "vuex";

export default {
  name: "Notify",
  data() {
    return {
      showTab: false,
    };
  },
  beforeMount() {
    this.GET_COMMS(this.user.id).then((r) => {
      if (r.status == 200) {
        for (let comm of r.data) {
          this.SET_NOTIFY(comm);

          if (comm.destaque && !comm.visualizado) {
            this.GET_COMM(comm.id_comunicado).then((template) => {
              this.SET_MODALS({
                ...comm,
                content: template.data,
                show: true,
                layout: "Comm",
              });
            });
          }
        }
      }
    });
  },
  methods: {
    ...mapActions("general", ["GET_COMM", "GET_COMMS"]),
    ...mapMutations("general", [
      "SET_NOTIFY_READED",
      "CLEAR_NOTIFY",
      "SET_NOTIFY",
      "SET_MODALS",
    ]),
    clicked() {
      this.showTab = !this.showTab;
      if (!this.showTab)
        this.notify.read.map((n) => {
          if (!n.id_comunicado) n.visualizado = true;
        });
    },
    openNotify(notify) {
      if (notify.id_comunicado) {
        this.clicked();
        this.GET_COMM(notify.id_comunicado).then((template) => {
          this.SET_MODALS({
            ...notify,
            content: template.data,
            show: true,
            layout: "Comm",
          });
        });
      }
    },
  },
  computed: {
    ...mapGetters("general", ["notify"]),
    ...mapGetters("user", ["user"]),
  },
};
</script>

<style lang="scss">
@use "@/assets/scss/vars.scss" as *;

.notify {
  margin-right: 20px;

  .clear {
    font-size: 0.8rem;
    text-align: center;
    padding: 0.8rem 0rem;
    color: $gray-4;
    letter-spacing: 0.1rem;
    font-weight: bold;

    &:hover {
      cursor: pointer;
      background: $green-1;
      color: $white;
    }
  }

  &-content {
    background-color: $white;
    cursor: pointer;
    color: $supporter-1;
  }

  .mask {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    z-index: 900;
  }

  .ball {
    margin-top: -45px;
    margin-right: -5px;
    float: right;
    border-radius: 50%;
    font-size: 18px;
    min-width: 20px;
    height: 20px;
    line-height: 22px;
    font-weight: bold;
    text-align: center;
    color: $font-color;
    background: white;
    border: 1.3px solid $supporter-1;
  }

  &-content {
    padding: 10px 12px;
    border-radius: 50%;

    @media (max-width: $small) {
      padding: 8px 10px;
    }

    &.active {
      background: $supporter-1;
      color: $white;
      box-shadow: $shadow;
    }
  }

  .container {
    padding-top: 14px;
    @include border();

    @media (max-width: $small) {
      right: 0px;
      left: 0px;
    }

    @media (min-width: $small) {
      margin-left: -185px;
      border-radius: 16px;
    }

    position: absolute;
    box-shadow: $shadow;
    z-index: 999;
    background: $white;
    margin-top: 12px;

    .tab {
      @media (max-width: $small) {
        width: 100%;
      }

      border-radius: 14px;
      width: 400px;
      max-height: 260px;
      overflow: auto;

      b {
        color: $purple
      }

      color: $supporter-1;

      li {
        padding: 19px;
        color: $gray-4;
        border-bottom: 1px solid $white-3;

        &.clickable:hover {
          cursor: pointer;
          background: $white-10;
        }

        &.new {
          background-color: $green-3;
        }
      }
    }
  }
}
</style>